"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGPreloadScene = void 0;
const KHPreloadScene_1 = require("./KH/KHPreloadScene");
class CTGPreloadScene extends KHPreloadScene_1.KHPreloadScene {
    constructor() {
        super("CTGPreloadScene");
    }
    nextScene() {
        // return "CTGGameScene";
        return "CTGMainMenuScene";
    }
    palette() {
        return [0x222222, 0xeeeeee, 0xac3232];
    }
    loadAssets() {
        super.loadAssets();
        this.load.bitmapFont('font', 'assets/small.png', 'assets/small.fnt');
        this.load.image('arrow', 'assets/arrow.png');
        this.load.image('dither', 'assets/dither2.png');
        this.load.atlas('c6', 'assets/c6.png', 'assets/c6.json');
        this.load.image('card_back', 'assets/cardback.png');
        this.load.image('pixel', 'assets/pixel.png');
        this.load.image('grate', 'assets/grate.png');
        this.load.image('frame', 'assets/frame.png');
        this.load.image('close', 'assets/close.png');
        this.load.image('popup', 'assets/popup9p.png');
        this.load.image('scroll_bar', 'assets/scroll_bar.png');
        this.load.image('title_frame', 'assets/title_frame2.png');
        this.load.atlas('ditheranim', 'assets/ditheranim_transparent.png', 'assets/ditheranim_transparent.json');
        this.load.spritesheet('selection_anim', 'assets/ants.png', { frameWidth: 13, frameHeight: 15 });
        this.load.audio('sfx_destroy', 'assets/rollover5.mp3');
        this.load.audio('sfx_cancel', 'assets/rollover6.mp3');
        this.load.audio('sfx_select', 'assets/click3.mp3');
        this.load.audio('sfx_clock1', 'assets/clock1.mp3');
        this.load.audio('sfx_clock2', 'assets/clock2.mp3');
        this.load.audio('main_menu', 'assets/main_menu.mp3');
        this.load.audio('win', 'assets/Victory.mp3');
        this.load.audio('lose', 'assets/Defeat.wav');
        this.load.audio('song1', 'assets/song_1.mp3');
        this.load.audio('song2', 'assets/song_2.mp3');
        this.load.audio('song3', 'assets/song_3.mp3');
        this.load.audio('song4', 'assets/song_4.mp3');
        this.load.audio('song5', 'assets/song_5.mp3');
        this.load.audio('song6', 'assets/song_6.mp3');
        this.load.audio('song7', 'assets/song_7.mp3');
        this.load.audio('song8', 'assets/song_8.mp3');
        this.load.audio('song9', 'assets/song_9.mp3');
        this.load.audio('song10', 'assets/song_10.mp3');
        this.scene.run("KHInputScene");
    }
}
exports.CTGPreloadScene = CTGPreloadScene;
